module.exports = __webpack_public_path__ + "static/media/2pic.514fb3c0.png";